<template>
  <div
    v-if="nodeInfo"
    class="publicity_w d_flex justify_content_sb align_item_c"
    :style="{
      background: `url(${require('@/assets/images/zUxUa133Z0yOzx15.png')})
    100% center/contain no-repeat`,
    }"
  >
    <div class="title fz20 font_w_bold">公示公告</div>
    <div
      class="content_w overflow_hidden fz14"
      @mouseenter="enter"
      @mouseleave="leave"
    >
      <div
        ref="scrollBox"
        :class="play ? 'scroll_box' : ''"
        :style="{ transform: `translateY(${translateY}px)` }"
      >
        <div
          v-for="(row, index) in nodeInfo.articles"
          :key="row.id"
          class="row_w d_flex"
        >
          <div class="d_flex align_item_c item_i">
            <span
              v-show="col1(index) && isLatest(col1(index).createdAt)"
              class="latest bc_EF3946 c_fff"
              >新</span>

            <router-link
              custom
              :to="`${nodeInfo.nodeInfoVo.infoModel.route}/${
                col1(index) && col1(index).id
              }`"
              class="text c_4D4D4D text_ellipsis"
            >
              <span
@click="onLinkClick(col1(index))"
>{{ col1(index) && col1(index).title }}
              </span>
            </router-link>
          </div>

          <div class="d_flex align_item_c item_i">
            <span
              v-show="col2(index) && isLatest(col2(index).createdAt)"
              class="latest bc_EF3946 c_fff"
              >新</span>

            <router-link
              custom
              :to="`${nodeInfo.nodeInfoVo.infoModel.route}/${
                col2(index) && col2(index).id
              }`"
              class="text c_4D4D4D text_ellipsis"
            >
              <span
@click="onLinkClick(col2(index))"
>{{ col2(index) && col2(index).title }}
              </span>
            </router-link>
          </div>

          <!--
            index变化的时候，数据嵌套满足以下情况：
            0    1
            2    3
            4    5
            6    7
          -->
        </div>

        <div
          v-if="!nodeInfo.articles || !nodeInfo.articles.length"
          style="height: 54px"
          class="x_y_center"
        >
          <img src="@/assets/images/empty_icon.png" alt="">
          <span style="margin: 0 0 0 10px" class="fz14">暂无数据</span>
        </div>
      </div>
    </div>

    <div class="read_more fz14 c_fff bc_0983CC cursor_pointer">
      <router-link
:to="`${nodeInfo.nodeInfoVo.nodeModel.route}/${childNodeId}`"
>查看更多</router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { cms_node_data } from '@/api/portal'
import Cookies from 'js-cookie'

export default {
  data() {
    return {
      nodeInfo: null, // 栏目信息（包括文章数据）
      childNodeId: null, // 子栏目id（用于跳转）

      scrollBox: null, // 滚动盒子
      scrollTimer: null, // 滚动定时器
      translateY: 0, // 滚动距离
      play: false, // 是否滚动
      interval: 4000 // 滚动时间间隔
    }
  },
  computed: {
    ...mapGetters(['siteInfo', 'nodeMap', 'oss_pub_domain']),

    isLatest() {
      return function(date) {
        const diffTime = new Date().getTime() - new Date(date).getTime()

        return diffTime / 1000 / 60 / 60 / 24 < 3 // 3天前的表示最新
      }
    },

    // 列1
    col1() {
      return function(index) {
        return this.nodeInfo.articles[index === 0 ? 0 : index * 2]
      }
    },
    // 列2
    col2() {
      return function(index) {
        return this.nodeInfo.articles[index === 0 ? 1 : index * 2 + 1]
      }
    }
  },
  watch:{
    'nodeInfo.articles'(n){
      if(n && n.length){
        this.scrollTimer && clearInterval(this.scrollTimer)
        this.scrollTimer = setInterval(this.startPlay, this.interval)
      }
    }
  },
  created() {
  },
  async mounted() {
    await this.getDataList()
    this.scrollBox = this.$refs.scrollBox
  },

  destroyed() {
    clearInterval(this.scrollTimer)
  },
  methods: {
    // 获取数据列表
    async getDataList() {
      const { data } = await cms_node_data([{ code: 'notice', dataRows: 6 }])

      this.nodeInfo = data[0]

      // 如果大于4条并且条数是奇数，则push空对象，避免滚动出问题
      if (
        this.nodeInfo.articles.length > 4 &&
        this.nodeInfo.articles.length % 2 !== 0
      ) {
        this.nodeInfo.articles.push({})
      }

      if (!this.nodeInfo) return

      const node = this.siteInfo.nodes.find(
        (i) => i.id === this.nodeInfo.nodeInfoVo.id
      )
      this.childNodeId = node?.children[0].id // 用于跳转，默认找栏目的第一个子栏目
      console.log('nodeInfo',this.nodeInfo)
    },
    // 点击链接
    onLinkClick(item) {
      Cookies.set('cmsNodeChlidId', this.nodeMap[item.kind])
    },

    // 开始滚动
    startPlay() {
      // 小于4条不需要滚动
      if (this.nodeInfo.articles.length <= 4) {
        clearInterval(this.scrollTimer)
        return
      }

      this.play = true
      this.translateY = -34
      setTimeout(() => {
        // 需要删除两条数据，因为一行占有两条数据，而每次都是根据行滚动
        this.nodeInfo.articles.push(this.nodeInfo.articles.shift())
        this.nodeInfo.articles.push(this.nodeInfo.articles.shift())
        this.play = false
        this.translateY = 0
      }, 500)
    },

    enter() {
      clearInterval(this.scrollTimer)
    },
    leave() {
      this.scrollTimer && clearInterval(this.scrollTimer)

      this.scrollTimer = setInterval(this.startPlay, this.interval)
    }
  }
}
</script>

<style lang="scss" scoped>
.publicity_w {
  height: 90px;
  padding: 0 20px;
  margin-bottom: 10px;
  box-sizing: border-box;

  .title {
    width: 40px;
    color: #d6773d;
  }
  .content_w {
    width: 996px;
    height: 54px;
    padding: 0 0 0 20px;
    border-left: 1px solid #e6e6e6;
    box-sizing: border-box;
  }
  .scroll_box {
    transition: transform 0.5s;
  }
  .read_more {
    padding: 6px 10px;
    border-radius: 15px;
    background-color: #3d9dd6;
  }

  .row_w {
    height: 20px;
    margin-bottom: 14px;
    &:last-child {
      margin: 0;
    }
    .item_i {
      flex-basis: 50%;

      .latest {
        padding: 2px 5px;
        border-radius: 4px;
        box-sizing: border-box;
        margin-right: 10px;
      }
      .text {
        display: inline-block;
        width: 420px;
        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
